import { Spin } from "antd";
import { OverviewGroupSummary } from "Services/Api/Dashboard/Types";
import { renderScoreCell, renderTagCell } from "./columns";
import styles from './GroupSummaryTable.module.scss';
import { useTranslation } from "react-i18next";

const TableDataCard = ({ data, loading }: { data: OverviewGroupSummary, loading: boolean }) => {
    const { t } = useTranslation();

    return <Spin spinning={loading} wrapperClassName={styles.loadingCard}>
        <div className={styles.cardMobileView}>
            <div className={styles.heading}>{data?.groupName || ''}</div>
            <div>
                <div className={styles.row}>
                    <div className={styles.label}>{t('newDashboard.summaryTable.headers.phishing')}</div>
                    {renderScoreCell(data?.phishingScore ?? 0)}
                </div>
                <div className={styles.row}>
                    <div className={styles.label}>{t('newDashboard.summaryTable.headers.training')}</div>
                    {renderScoreCell(data?.elearningScore ?? 0)}
                </div>
                <div className={styles.row}>
                    <div className={styles.label}>{t('newDashboard.summaryTable.headers.saqCompliance')}</div>
                    {renderTagCell(data?.saqStatus ?? "", t)}
                </div>
                <div className={styles.row}>
                    <div className={styles.label}>{t('newDashboard.summaryTable.headers.scanning')}</div>
                    {renderTagCell(data?.scanningStatus ?? "", t)}
                </div>
            </div>
        </div>
    </Spin>
}

export default TableDataCard;